import styled from "styled-components";
import { DefaultButton } from "./defaultButton";

export const PrimaryButton = styled(DefaultButton)`
	background-color: ${({ theme }) => theme.colors.primary};
	color: ${({ theme }) => theme.colors.white};

	transition: background-color 0.2s linear;
	&:hover  {
		background-color: ${({ theme }) => theme.colors.primaryTouch};
	}
`;

export const SecondaryTouchButton = styled(DefaultButton)`
	background-color: ${({ theme }) => theme.colors.secondary};
	color: ${({ theme }) => theme.colors.white};

	transition: background-color 0.2s linear;
	&:hover  {
		background-color: ${({ theme }) => theme.colors.secondaryTouch};
	}
`;
